module.exports = __webpack_public_path__ + "static/assets/cc4d68fe9d6a77c7f35f9d5461b60967.png";